import BaseService from '../BaseService'

class OrderService extends BaseService {
constructor() {
    super('/orders');
}
}

export default new OrderService()
